import React from "react";
import Image from "next/image";
import classNames from "classnames";

// components
import Link from "@/components/Link";

//helpers
import { useDimension } from "@/hooks/useDimensions";

// assets
import LoLiveLogoIconWeriFooter from "@/components/icons/SupportUkraine/LoLiveLogoIconWeriFooter";
import HouseLocationPin from "@/components/icons/HouseLocationPin";
import MailIcon from "@/components/icons/MailIcon";
import PhoneCallIcon from "@/components/icons/PhoneCallIcon";
import weriLogoLightSmall from "@/assets/images/landing/logo/weri-logo-light-small.png";

//styles
import styles from "@/assets/styles/components/Footer/landing-footer.module.scss";

const WERIFooter = ({ className }: { className?: string }) => {
  const [width] = useDimension();
  const footerClassNames = classNames(styles.Footer, styles["locl-footer-weri"], className);

  const isDesktop = width > 870;

  const contactsBlockClassName = styles["locl-footer-weri__contacts-block"];
  const contactsBlockLabelClassName = styles["locl-footer-weri__contacts-block__label"];
  const bottomNavBoxClassName = styles["locl-footer-weri__bottom__nav-box"];

  return (
    <footer className={footerClassNames}>
      <div className={styles["locl-footer-weri__heading"]}>
        <a href="#" className={styles["locl-footer-weri__heading__logo"]}>
          <Image
            width={137}
            height={60}
            src={weriLogoLightSmall}
            loading="lazy"
            alt="App Logo"
            className={styles["locl-footer-weri__heading__logo-image"]}
          />
        </a>
        <div className={styles["locl-footer-weri__contacts"]}>
          <div className={styles["locl-footer-weri__contacts-col"]}>
            <div className={contactsBlockClassName}>
              {isDesktop && <MailIcon />}
              <a
                href="mailto:hello@locationlive.com"
                className={contactsBlockLabelClassName}
              >
                hello@locationlive.com
              </a>
            </div>
            <div className={contactsBlockClassName}>
              {isDesktop && <PhoneCallIcon />}
              <a
                href="tel:+4402089355033"
                className={contactsBlockLabelClassName}
              >
                +44 (0)208 935 5033
              </a>
            </div>
          </div>
          <div className={styles["locl-footer-weri__contacts-col"]}>
            <div className={contactsBlockClassName}>
              {isDesktop && <HouseLocationPin />}
              <a
                href="https://goo.gl/maps/pHjQYpUPH9NjHWbf6"
                className={contactsBlockLabelClassName}
                target="_blank"
                rel="noreferrer"
              >
                The Courtyard, 37 Sheen Road,
                <br /> Richmond Upon Thames, TW9 1AJ
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["locl-footer-weri__bottom"]}>
        <div className={styles["locl-footer-weri__bottom__nav"]}>
          <Link
            href="/terms-of-use"
            target="_blank"
            className={bottomNavBoxClassName}
            rel="noreferrer"
          >
            Terms of Use
          </Link>
          <Link
            href="/bookingterms"
            target="_blank"
            className={bottomNavBoxClassName}
            rel="noreferrer"
          >
            Booking Terms
          </Link>
          <Link
            href="/privacy"
            target="_blank"
            className={bottomNavBoxClassName}
            rel="noreferrer"
          >
            Privacy Policy
          </Link>
          <Link
            href="/cookies"
            target="_blank"
            className={bottomNavBoxClassName}
            rel="noreferrer"
          >
            Cookie Notice
          </Link>
        </div>
        <a href="#" className={styles["locl-footer-weri__bottom__logo"]}>
          <div className={styles["locl-footer-weri__bottom__logo-text"]}>Powered by</div>
          <LoLiveLogoIconWeriFooter
            className={styles["locl-footer-weri__bottom__logo-icon"]}
            textColor="#fff"
          />
        </a>
      </div>
    </footer>
  );
};

export default WERIFooter;
